import { Calendar, Information } from 'assets/icons';
import Button from 'components/button';
import ModalBody from 'components/modal/components/body';
import ModalFooter from 'components/modal/components/footer';
import Modalheader from 'components/modal/components/header';
import useModal from 'components/modal/useModal';
import UseContext from 'hooks/useContext';
import { useState } from 'react';
import DatePicker from 'react-datepicker';

const AttenteRecrutement = () => {
  const { dataCreateMission, setDataCreateMission } = UseContext();
  const { toggle } = useModal();

  const [message, setMessage] = useState(() => {
    if (dataCreateMission?.motif?.type === '2') {
      return {
        type: '2',
        name: dataCreateMission.motif.name || '',
        prenom: dataCreateMission.motif.prenom || '',
        date: dataCreateMission.motif.date || '',
      };
    }
    return { type: '2', name: '', prenom: '', date: '' };
  });

  const [errorName, setErrorName] = useState(false);
  const [errorPrenom, setErrorPrenom] = useState(false);
  const [errorDate, setErrorDate] = useState(false);

  const handleChange = (e) => {
    const { name, type, value } = e.target;
    setMessage((prev) => ({
      ...prev,
      [name]: type === 'checkbox' ? e.target.checked : value,
    }));
  };

  const handleSubmit = () => {
    setErrorName(!message.name);
    setErrorPrenom(!message.prenom);
    setErrorDate(!message.date);

    if (message.name && message.prenom && message.date) {
      setDataCreateMission((prevData) => ({
        ...prevData,
        motif: message,
      }));
      toggle();
    }
  };

  return (
    <>
      <Modalheader hide={toggle} hideShow={true}>
        En attente de recrutement
      </Modalheader>
      <ModalBody>
        <div className="grid grid-cols-2 gap-6">
          <div>
            <label
              htmlFor="name"
              className="block ft-sm font-medium text-gray-500"
            >
              Nom
            </label>
            <input
              name="name"
              value={message.name}
              onChange={handleChange}
              className="w-full h-10 pl-3 pr-8 ft-b placeholder-gray-600 border rounded-lg"
              type="text"
              required
            />
            {errorName && (
              <p className="text-yellow-400 flex items-center gap-4">
                <Information wh={16} color={'#FFA43D'} />
                Un nom est requis
              </p>
            )}
          </div>
          <div>
            <label
              htmlFor="prenom"
              className="block ft-sm font-medium text-gray-500"
            >
              Prénom
            </label>
            <input
              name="prenom"
              value={message.prenom}
              onChange={handleChange}
              className="w-full h-10 pl-3 pr-8 ft-b placeholder-gray-600 border rounded-lg"
              type="text"
              required
            />
            {errorPrenom && (
              <p className="text-yellow-400 flex items-center gap-4">
                <Information wh={16} color={'#FFA43D'} />
                Un prénom est requis
              </p>
            )}
          </div>
          <div className="col-span-2">
            <label
              htmlFor="date"
              className="block ft-sm font-medium text-gray-500"
            >
              Date
            </label>
            <div className="relative">
              <DatePicker
                dateFormat="dd/MM/yyyy"
                selected={message.date}
                onChange={(date) => setMessage((prev) => ({ ...prev, date }))}
                peekNextMonth
                locale="fr-FR"
                showMonthDropdown
                showYearDropdown
                dropdownMode="select"
                popperPlacement="bottom"
                className="w-full h-10 pl-3 pr-8 ft-b border rounded-lg text-center cursor-pointer"
              />
              <div className="absolute inset-y-0 left-0 flex items-center px-2 pointer-events-none">
                <Calendar wh={18} color={'#666666'} strokeW={2} />
              </div>
            </div>
            {errorDate && (
              <p className="text-yellow-400 flex items-center gap-4">
                <Information wh={16} color={'#FFA43D'} />
                Une date est requise
              </p>
            )}
          </div>
        </div>
      </ModalBody>
      <ModalFooter>
        <Button size={'LG'} color={'SECONDARY'} onClick={toggle}>
          Annuler
        </Button>
        <Button size={'LG'} onClick={handleSubmit}>
          Confirmer
        </Button>
      </ModalFooter>
    </>
  );
};

export default AttenteRecrutement;
